import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillService {

  constructor(private http: HttpClient) { }

  searchBill(request: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/searchBill`;
    return this.http.post(url, request);
  }

  updateBill(updateList: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/updateBilling`;
    return this.http.post(url, updateList);
  }

  async getDailyRate(orgId: string, guiCurrency: string, linePayCurrency: string): Promise<any> {
    const url = `${environment.wpgApiUrl}/common/getDailyRates/${orgId}/${guiCurrency}/${linePayCurrency}`;
    return this.http.get(url).toPromise();
  }


  importBillExcel(file: any, codeKey: string, user: string, userType: string, facility: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('codeKey', codeKey);
    formData.append('user', user);
    formData.append('userType', userType);
    formData.append('facility', facility);

    const url = `${environment.expenseApiUrl}/billing/bulk`;
    let response = this.http.put(url, formData, { responseType: 'blob', observe: 'response' });
    return response;
  }

  previewExcel(file: any,): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    const url = `${environment.expenseApiUrl}/billing/billExcelPreview`;
    let response = this.http.post(url, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return response;
  }

  getBillExcel(form: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/bulk`;
    return this.http.post(url, form, { responseType: 'blob' });
  }

  confirmPaymentApplication(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/confirm`;
    return this.http.post(url, updateObj);
  }
  checkBillData(requestParam: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/expense/importBilling/searchBillingImport`;
    return this.http.post(url, requestParam);
  }

  cancelPaymentApplication(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/cancel`;
    return this.http.put(url, updateObj);
  }
  saveBillingImport(requestParam: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/saveBillingImport`;
    return this.http.post(url, requestParam);
  }

  importBilling(requestParam: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/importBilling`;
    return this.http.post(url, requestParam);
  }

  getBillingStatus(billingNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/billing/getBillingStatus`;
    return this.http.post(url, billingNo);
  }

  checkBill(requestParam: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/checkBill`;
    return this.http.post(url, requestParam, { responseType: 'blob', observe: 'response' });
  }
}
